import { OrganizationCard } from '../components/OrganizationCard';

export function OrganizationSection() {
  return <OrganizationCard />;
}
